/**
 * @sw-package inventory
 */
const PluginManager = window.PluginManager;

if (window.swagProductBundlesLicensed) {
    PluginManager.register(
        'ShowMoreButton',
        () => import('./plugin/show-more-button/show-more-button.plugin'),
        '[data-show-more-button]',
    );

    PluginManager.register(
        'BundleAccessibility',
        () => import('./plugin/bundle-accessibility/bundle-accessibility.plugin'),
        '[data-bundle-accessibility]',
    );

    PluginManager.register(
        'BundleItemConfiguration',
        () => import('./plugin/bundle-item-configuration/bundle-item-configuration.plugin'),
        '[data-bundle-item-configuration]',
    );

    PluginManager.register(
        'BundleRestoreUndo',
        () => import('./plugin/bundle-restore-undo/bundle-restore-undo.plugin'),
        '.js-bundle-restore-undo',
    );

    PluginManager.register(
        'BundleItemNotice',
        () => import('./plugin/bundle-item-notice/bundle-item-notice.plugin'),
        '[data-bundle-item-notice-host]',
    );

    PluginManager.register(
        'BundleItemConfigureModal',
        () => import('./plugin/bundle-item-configure-modal/bundle-item-configure-modal.plugin'),
        '[data-bundle-item-configure-modal]',
    );

    PluginManager.register(
        'BundleConfigurationPreview',
        () => import('./plugin/bundle-configuration-preview/bundle-configuration-preview.plugin'),
        '[data-bundle-configuration-preview]',
    );

    PluginManager.register(
        'BundleQuantitySync',
        () => import('./plugin/bundle-quantity-sync/bundle-quantity-sync.plugin'),
        '[data-bundle-quantity-sync]',
    );
}
